export const itemModalCustomStyles = {
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.53)',
    zIndex: 100
  },
  content: {
    top: '50%',
    left: '50%',
    right: '-50%',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
    maxHeight: '80%',
    padding: '0',
    border: 'none',
    maxWidth: '355px'
  }
}
